import Vue from "vue"; //引入Vue
import Router from "vue-router"; //引入vue-router
import { syncSafeAreaInsetTop } from "@/utils/safeArea";
Vue.use(Router); //Vue全局使用Router

const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: "/index",
      name: "index",
      meta: { navTitle: "万口得" },
      component: (resolve) => require(["../views/index"], resolve),
    },
    {
      path: "/",
      redirect: "/index",
    },
	{
		   path: '/guide',
		   name: 'guide',
		   meta: { navTitle: '一瓶一码', navBadge: true, navBack: 'uni' },
		   component: () => import('../views/guide.vue')
	},
	{
		  path:'/fengtu',
		  name:'fengtu',
		  meta: { navTitle: '风土' },
		  component: () => import('../views/fengtu.vue')
	},
	{
		  path:'/meteorology',
		  name:'meteorology',
		  meta: { navTitle: '风土信息看板' },
		  component: () => import('../views/meteorology.vue')
	},
	{
		  path:'/zhongzhi',
		  name:'zhongzhi',
		  meta: { navTitle: '种植' },
		  component: () => import('../views/zhongzhi.vue')
	},
	{
		  path:'/niangzao',
		  name:'niangzao',
		  meta: { navTitle: '酿造及藏储' },
		  component: () => import('../views/niangzao.vue')
	},
	{
		  path:'/good',
		  name:'good',
		  meta: { navTitle: '商品' },
		  component: () => import('../views/good.vue')
	},
	{
		  path:'/source',
		  name:'source',
		  meta: { hideNav: true },
		  component: () => import('../views/source.vue')
	},
	{
		  path:'/share',
		  name:'share',
		  meta: { navTitle: '万口得' },
		  component: () => import('../views/share.vue')
	},
	{
		  path:'/agreement',
		  name:'agreement',
		  meta: { navTitle: '用户协议' },
		  component: () => import('../views/agreement.vue')
	},
	{
		  path:'/privacy',
		  name:'privacy',
		  meta: { navTitle: '隐私政策' },
		  component: () => import('../views/privacy.vue')
	},
	{
		  path:'/digitalWinery',
		  name:'digitalWinery',
		  meta: { navTitle: '数字酒庄' },
		  component: () => import('../views/digitalWinery.vue')
	}
  ],
});

router.afterEach(() => {
	Vue.nextTick(() => syncSafeAreaInsetTop());
});

export default router;
